import { Component, ViewChild } from '@angular/core';
import { IonicPage } from 'ionic-angular';
import { AppConfig } from '../../../app/app.config';
import { DailyLogService } from '../../../services/daily-log/daily-log.service';
import { PtLuxonDate } from '../../../models/projects/date.models';
import { ValidationResult } from '../../../models/projects/validation.models';
import { DailyLogDatePickerComponent } from '../../shared/components/daily-log-date-picker/daily-log-date-picker';

import { JackingActivityListComponent } from '../v1/jacking-activity-list-component/jacking-activity-list-component.component';
import { JackingActivityListV2Component } from '../v2/jacking-activity-list-v2/jacking-activity-list-v2.component';

@IonicPage()
@Component({
  selector: 'page-jacking-activities-router',
  templateUrl: 'jacking-activities-router-page.html',
})
export class JackingActivitiesRouterPage {
  @ViewChild('dailyLogDatePickerComponent') dailyLogDatePickerComponent?: DailyLogDatePickerComponent;
  @ViewChild('v1') v1?: JackingActivityListComponent;
  @ViewChild('v2') v2?: JackingActivityListV2Component;

  config = AppConfig.settings;

  // only what the date picker + empty state needs
  validationResult: ValidationResult = new ValidationResult();
  validationLoading = false;
  dateLoading = false;
  firstLoadComplete = false;
  dateBeforeInitialSetup = false;

  useV2 = false;
  dailyLogDate: PtLuxonDate = new PtLuxonDate();

  constructor(private dailyLogService: DailyLogService) {}

  async ionViewWillEnter() {
    await this.refreshVersionAndLoad();
  }

  async onDateChange() {
    if (!this.firstLoadComplete) {
      return;
    }

    this.dateLoading = true;
    try {
      await this.refreshVersionAndLoad();
    } finally {
      this.firstLoadComplete = true;
    }
  }

  async onDayUnlockedForEditing() {
    if (this.useV2) {
      await this.v2?.dayUnlockedForEditing();
    } else {
      await this.v1?.dayUnlockedForEditing();
    }
  }

  onDateBeforeInitialSetupChanged(value: boolean) {
    this.dateBeforeInitialSetup = value;

    // optional: let child know too
    if (this.useV2) {
      this.v2?.dateBeforeInitialSetupChanged(value);
    } else {
      this.v1?.dateBeforeInitialSetupChanged(value);
    }
  }

  goToActiveLogDay() {
    this.dailyLogDatePickerComponent?.goToActiveLogDay();
  }

  // child -> router (binds back into picker)
  onChildUiChange(patch: {
    validationResult?: ValidationResult;
    validationLoading?: boolean;
    loading?: boolean;
    firstLoadComplete?: boolean;
  }) {
    if (patch.loading !== undefined) { this.dateLoading = patch.loading; }
    if (patch.validationResult !== undefined) { this.validationResult = patch.validationResult; }
    if (patch.validationLoading !== undefined) { this.validationLoading = patch.validationLoading; }
    if (patch.firstLoadComplete !== undefined) { this.firstLoadComplete = patch.firstLoadComplete; }
  }

  private async refreshVersionAndLoad() {
    this.dailyLogDate = await this.dailyLogService.getCurrentLogDay();

    const dateUtcMillis = this.dailyLogDate.dateTime.toUTC().toMillis();
    this.useV2 = dateUtcMillis >= this.config.jackingV2StartDateUtc.toMillis();

    if (this.useV2) {
      await this.waitForV2();
      setTimeout(async () => {
        await this.v2.loadForDate(this.dailyLogDate);
      }, 300);
    } else {
      await this.waitForV1();
      await this.v1.loadForDate(this.dailyLogDate, true);
    }

    this.firstLoadComplete = true;
  }

  loadingDateChange() {
    this.dateLoading = true;
  }

  private waitForV1(): Promise<void> {
    return new Promise(resolve => {
      const tick = () => {
        if (this.v1) {
          resolve();
          return;
        }
        setTimeout(tick, 0);
      };
      tick();
    });
  }

  private waitForV2(): Promise<void> {
    return new Promise(resolve => {
      const tick = () => {
        if (this.v2) {
          resolve();
          return;
        }
        setTimeout(tick, 0);
      };
      tick();
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/jacking-activities-router/jacking-activities-router-page.ts